import Http from "./Http";

export default class Socket {
  static instance = null;

  /**
   * 获取实例
   * @returns {Socket}
   */
  static getInstance() {
    if (!Socket.instance) {
      Socket.instance = new Socket();
    }
    return Socket.instance;
  }
  host_url = "https://meter.gdzawy.com:9001";
  socket = null;
  peer=null;

  constructor() {
    let token = localStorage.getItem("token");
    if (token) {
      let name = localStorage.getItem("login");
      let user_id = localStorage.getItem("oa_user_id");
      const socket = io(`${this.host_url}?token=${token}&name=${name}&user_id=${user_id}`, {
        path: "/socket.io/", // 自定义路径
        withCredentials: true, // 带上cookie
        transports: ["websocket", "polling"], // 传输协议
        reconnection: true, // 自动重连
        reconnectionDelay: 3000, // 重连间隔
        reconnectionDelayMax: 5000, // 最大重连间隔
        timeout: 20000, // 超时时间
        maxReconnectionAttempts: 5, // 最大重连次数
        autoConnect: true, // 自动连接

      });
      socket.on("message", (data) => {
        console.log("message", data);
      });
      socket.on("connect", () => {
        console.log("socket连接成功");
        this.peer&&this.peer.connect();
      });
      socket.on("disconnect", () => {
        console.log("socket断开连接");
        this.peer&&this.peer.disconnect();
      });
      socket.on("reconnect", () => {
        console.log("socket重新连接");
      });
      socket.on("reconnect_attempt", () => {
        console.log("socket尝试重新连接");
      });
      socket.on("reconnect_error", () => {
        console.log("socket重新连接失败");
      });
      socket.on("reconnect_failed", () => {
        console.log("socket重新连接失败");
      });
      this.socket = socket;
    } else {
      console.warn("socket token not found");
      this.socket = {};
    }
  }

  static reSocket(){
    Socket.instance = new Socket();
    return Socket.instance;
  }

  /**
   * 获取socket实例
   */
  getSocket(){
    return this.socket;
  }

  /**
   * 获取socket id
   */
  getSocketId(){
    return this.socket.id;
  }

  /**
   * 监听事件
   * @param event
   * @param callback
   */
  on(event, callback) {
    const that = this;
    that.socket.on(event, (data) => {
      callback(JSON.parse(data));
    });
  }

  /**
   * 取消监听事件
   * @param event
   * @param callback
   */
  off(event, callback) {
    this.socket.off(event, callback);
  }

  /**
   * 发送事件
   * @param event
   * @param data
   */
  emit(event, data) {
    this.socket.emit(event, JSON.stringify(data));
  }

  /**
   * 关闭连接
   */
  disconnect() {
    this.socket.disconnect();
  }

  /**
   * 连接
   */
  connect() {
    this.socket.connect();
  }

  /**
   * 重新连接
   */
  reconnect() {
    this.socket.reconnect();
  }

  /**
   * 关闭连接
   */
  close() {
    this.socket.close();
  }

  /**
   * 发送消息
   * @param toToken
   * @param content
   * @param event
   */
  send(toToken,content,event='message'){
    let url = `${this.host_url}/socketApi/send`;
    this.sendHandler({
      toToken: toToken,
      content: content,
      event: event
    });
  }

  sendSocketId(toSocketId,content,event='message'){
    let url = `${this.host_url}/socketApi/send`;
    this.sendHandler({
      toSocketId: toSocketId,
      content: content,
      event: event
    });
  }

  sendHandler(data){
    let url = `${this.host_url}/socketApi/send`;
    Http.post(url, data, (res) => {
      if (res.status != 200) {
        console.log("发送失败");
      }
    });
  }

  /**
   * 获取用户列表
   * @param callback
   */
  getUserList(callback){
    let url = `${this.host_url}/socketApi/user`;
    Http.get(url,{},userList=>{
      callback&&callback(userList)
    })
  }

  /**
   * 获取服务信息
   * @param callback
   */
  getStatistical(callback){
    let url = `${this.host_url}/socketApi/statistical`;
    Http.get(url,{},ret=>{
      if(ret.status==200){
        callback&&callback(ret.data)
      }
    })
  }

  bindPeer(peer){
    this.peer=peer;
    let url = `${this.host_url}/socketApi/bindPeer`;
    Http.post(url,{peerId:peer.id,socketId:this.getSocketId()},ret=>{
      if(ret.status==200){
        // callback&&callback(ret.data)
      }
    })
  }

  callScreen(socket_id){

  }


}



// WEBPACK FOOTER //
// ./src/common/Socket.js